import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLine from "./components/LiftLine";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";

const Lift11 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift11"
			 className={getLiftClass(isOpen, activeLiftId === '11', state)}
			 transform="translate(2179.000000, 424.000000)"
		>
			<LiftLine x1="77.5" y1="138.5" x2="15.299478" y2="412.885631" color={colors[0]}/>
			<LiftLabelTypeSeat
				colors={getLiftStatusColors(state, isOpen)}
				seatCount="4"
				isOpen={isOpen}
				coords="54.000000, 147.000000"/>

			<LiftLine x1="110.5" y1="13.5" x2="87.5" y2="95.5" color={colors[0]}/>

			<g id="Labe-lift" transform="translate(0.000000, 410.000000)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.547130, 422.547130) scale(-1, 1) rotate(77.000000) translate(-13.547130, -422.547130) "
				points="8.04712957 422.54713 19.0471296 417.04713 16.6756423 422.54713 19.0471296 428.04713"/>

			<LabelLift isOpen={isOpen} text={<tspan x="-3" y="13">11</tspan>} coords={'99.000000, 0.000000'} state={state}/>
		</g>
	);
};


Lift11.propTypes = {};

export default Lift11;
